import { styled } from '@mui/material';

const HorizontalLine = styled('hr')(({ theme, disabled }) => ({
    minWidth: '8px',
    border: 'none',
    borderTop: `1px solid ${disabled ? theme.palette.N50.main : theme.palette.N20.main}`,
    margin: '15px 6px 0 0',
    opacity: disabled ? 0.5 : 1,
}));

export { HorizontalLine };
//# sourceMappingURL=HorizontalLine.js.map
